import docsPng from "shared/assets/docs.png";
import { Img } from "shared/ui/img";
import { cn } from "shared/utils/cn";

export const NoCerts = ({ className }: { className?: string }) => {
  return (
    <div className={cn("flex flex-col items-center justify-center", className)}>
      <Img src={docsPng} alt="no certs" className="max-w-44" />
      <p className="text-balticSea/50 mt-7 max-w-2xs text-center font-medium whitespace-pre-line">
        {`You haven't received any\ncertificates yet. Get one now!`}
      </p>
    </div>
  );
};
